import { useShellHost } from "@/shell-handle/ShellHostProvider";
import { Button, Icon, Styles } from "@/shared/coralreef";
import { faBan, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { important, percent, px, rem, viewHeight } from "csx";
import { Content, Horizontal, Stretch, Vertical } from "gls";
import { useTranslation } from "react-i18next";
import { style } from "typestyle";

export const AccessDeniedPage = () => {
  const host = useShellHost();
  const { t } = useTranslation();

  const handleSignOut = async () => {
    try {
      await host.auth.signOut();
    } catch {
      /* fall through to redirect */
    }
    window.location.assign("/login");
  };

  return (
    <Stretch
      width={percent(100)}
      padding={[viewHeight(20), 0, 0, 0]}
      horizontalAlign="center"
      className={style({
        color: Styles.Colours.textLight,
      })}
    >
      <Icon
        icon={faBan}
        className={style({
          width: important(rem(8)),
          height: important(rem(8)),
        })}
      />
      <div className="text-xl pb-5">{t("Access Denied")}</div>
      <Vertical
        horizontalAlign="center"
        spacing={rem(1)}
        className={style({
          color: Styles.Colours.textLight,
        })}
      >
        <Content>{t("You don't have access to this page")}</Content>
        <Content>{t("Please contact your administrator")}</Content>
        <Horizontal width={percent(100)} verticalAlign="center">
          <Divider />
          <Content
            className={style({
              color: Styles.Colours.textDisabled,
            })}
          >
            {t("or")}
          </Content>
          <Divider />
        </Horizontal>

        <Button
          content={t("Sign out")}
          icon={faSignOutAlt}
          appearance="hollow"
          onClick={handleSignOut}
        />
      </Vertical>
    </Stretch>
  );
};

const Divider = () => (
  <Stretch
    className={style({
      height: px(1),
      background: Styles.Colours.textDisabled,
    })}
  />
);
